/** The default-language contract (backend AIE D21, dev-platform A0): in an ordered language
 *  list — a tenant's `config.i18n.lang_enabled`, a tour's `available_langs` — the LAST item is
 *  the default language. Order carries meaning: a language that must not become the default goes
 *  before the last item. Every console reader takes the default from here (backend twin:
 *  `demo/lib/i18n/default_lang.py`). */
export function defaultLang(langs: readonly string[] | null | undefined): string | undefined;
export function defaultLang(langs: readonly string[] | null | undefined, fallback: string): string;
export function defaultLang(
  langs: readonly string[] | null | undefined,
  fallback?: string,
): string | undefined {
  return langs && langs.length > 0 ? langs[langs.length - 1] : fallback;
}

/** `langs` with `lang` as the last item — the default — moved there or appended; the others keep
 *  their order. */
export function withDefaultLast(langs: readonly string[], lang: string): string[] {
  return [...langs.filter((l) => l !== lang), lang];
}
